import { z } from "zod";

export const PROTOCOL_VERSION = 1 as const;

export type StyxFrame = {
  v: typeof PROTOCOL_VERSION;
  type: string;
  id: string;
  ts: number;
  payload: Record<string, unknown>;
};

const UUID_V4 =
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const uuidV4String = z.string().regex(UUID_V4);

const styxEnvelopeSchema = z.object({
  v: z.literal(1),
  type: z.string().min(1).max(128),
  id: uuidV4String,
  ts: z.number().finite().nonnegative(),
  payload: z.record(z.string(), z.unknown()),
});

export function newFrameId(): string {
  return crypto.randomUUID();
}

export function buildFrame(type: string, payload: Record<string, unknown>, id?: string): StyxFrame {
  return {
    v: PROTOCOL_VERSION,
    type,
    id: id ?? newFrameId(),
    ts: Date.now(),
    payload,
  };
}

export function parseFrame(raw: string): StyxFrame | null {
  try {
    const o = JSON.parse(raw) as unknown;
    const r = styxEnvelopeSchema.safeParse(o);
    if (!r.success) return null;
    const d = r.data;
    return {
      v: 1,
      type: d.type,
      id: d.id,
      ts: d.ts,
      payload: d.payload,
    };
  } catch {
    return null;
  }
}

export function serializeFrame(f: StyxFrame): string {
  return JSON.stringify(f);
}
